(() => {
  const sectionSelector = '.mp-page-native-static';

  const initSlider = (slider) => {
    if (slider.dataset.mpNativeSliderReady === 'true') return;
    const wrapper = slider.querySelector(':scope > .ecom-swiper-wrapper');
    const container = slider.closest('.ecom-slider--container') || slider.parentElement || slider;
    const markReady = () => {
      slider.dataset.mpNativeSliderReady = 'true';
      slider.classList.add('ecom-swiper-initialized', 'ecom-swiper-horizontal', 'ecom-swiper-container-initialized');
      container.classList.add('ecom-swiper-initialized-wrapper');
      wrapper?.classList.add('ecom-swiper-initialized-wrapper');
      slider.style.opacity = '1';
      slider.style.visibility = 'visible';
    };
    markReady();
    if (!wrapper) {
      return;
    }
    const slides = [...wrapper.children].filter((node) => node.classList.contains('ecom-swiper-slide'));
    const row = slider.closest('.ecom-row');
    row?.classList.add('mp-native-static-fragment');
    slider.style.width = '100%';
    slider.style.maxWidth = '100%';
    slider.style.minWidth = '0';
    slider.style.overflow = 'hidden';
    slider.style.opacity = '1';
    slider.style.visibility = 'visible';
    wrapper.style.display = 'flex';
    wrapper.style.width = '100%';
    wrapper.style.maxWidth = '100%';
    wrapper.style.minWidth = '0';
    wrapper.style.boxSizing = 'border-box';
    wrapper.style.opacity = '1';
    wrapper.style.visibility = 'visible';
    if (!slider.closest('.mp-page-native-static-layout-v2')) {
      let layoutNode = slider.parentElement;
      while (layoutNode && layoutNode !== row && !layoutNode.classList.contains('core__column--wrapper')) {
        layoutNode.style.width = '100%';
        layoutNode.style.maxWidth = '100%';
        layoutNode.style.minWidth = '0';
        layoutNode.style.boxSizing = 'border-box';
        layoutNode = layoutNode.parentElement;
      }
    }

    const previous = container.querySelector('.ecom-swiper-button-prev');
    const next = container.querySelector('.ecom-swiper-button-next');
    const pagination = container.querySelector('.ecom-swiper-pagination');
    const setDisabled = (control, disabled) => {
      if (!control) return;
      control.disabled = disabled;
      control.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    };

    if (slides.length < 2) {
      wrapper.style.transform = 'translate3d(0, 0, 0)';
      slides.forEach((slide) => {
        slide.style.flex = '0 0 100%';
        slide.style.opacity = '1';
        slide.style.visibility = 'visible';
        slide.style.transform = 'translate3d(0, 0, 0)';
        slide.classList.add('swiper-slide-active', 'ecom-box-active');
        slide.setAttribute('aria-hidden', 'false');
      });
      setDisabled(previous, true);
      setDisabled(next, true);
      if (pagination) {
        pagination.replaceChildren();
        pagination.setAttribute('aria-disabled', 'true');
      }
      return;
    }

    pagination?.removeAttribute('aria-disabled');

    let options = {};
    try {
      options = JSON.parse(slider.dataset.optionSwiper || '{}');
    } catch (error) {
      options = {};
    }

    const assuranceSlider = !slider.hasAttribute('data-option-swiper')
      && slides.length === 4
      && row?.matches('aside.ecom-row')
      && row.parentElement?.matches('.ecom-sections')
      && row.parentElement.parentElement?.matches('.ecom-builder')
      && row.closest('.mp-page-native-static')
      && slides.every((slide) => slide.querySelector('.ecom-base-iconlist'));

    if (assuranceSlider) {
      options = {
        slidesPerView: 1,
        breakpoints: {
          0: { slidesPerView: 1 },
          768: { slidesPerView: 3 },
          1025: { slidesPerView: 4, spaceBetween: 0 },
        },
        loop: true,
        speed: 1000,
        watchOverflow: true,
        autoplay: {
          enabled: true,
          delay: 6000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
          reverseDirection: false,
        },
      };

      [previous, next, pagination].forEach((control) => {
        if (!control) return;
        control.style.display = 'none';
        control.setAttribute('aria-hidden', 'true');
        control.tabIndex = -1;
      });
      setDisabled(previous, true);
      setDisabled(next, true);
      pagination?.replaceChildren();

      const state = { index: 0, timer: 0, paused: false };
      const slidesPerView = () => {
        const width = window.innerWidth;
        const key = width >= 1025 ? '1025' : width >= 768 ? '768' : '0';
        return Math.max(1, Math.min(slides.length, Number(options.breakpoints[key].slidesPerView) || 1));
      };
      const setSlideState = () => {
        const perView = slidesPerView();
        slides.forEach((slide, index) => {
          const offset = (index - state.index + slides.length) % slides.length;
          const active = offset < perView;
          slide.style.flex = `0 0 ${100 / perView}%`;
          slide.classList.toggle('swiper-slide-active', active);
          slide.classList.toggle('ecom-box-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
      };
      const orderSlides = (startIndex) => {
        Array.from({ length: slides.length }, (_, offset) => slides[(startIndex + offset) % slides.length])
          .forEach((slide) => wrapper.appendChild(slide));
      };
      const settle = () => {
        orderSlides(state.index);
        wrapper.style.transitionProperty = 'transform';
        wrapper.style.transitionTimingFunction = 'ease';
        wrapper.style.transitionDuration = '0ms';
        wrapper.style.transform = 'translate3d(0, 0, 0)';
        setSlideState();
      };
      const schedule = () => {
        window.clearTimeout(state.timer);
        if (state.paused || slidesPerView() >= slides.length) return;
        state.timer = window.setTimeout(() => move(1, true), options.autoplay.delay);
      };
      const move = (direction, fromAutoplay = false) => {
        if (slidesPerView() >= slides.length) {
          if (fromAutoplay) schedule();
          return;
        }
        state.index = (state.index + direction + slides.length) % slides.length;
        settle();
        if (fromAutoplay) schedule();
      };

      window.addEventListener('resize', () => {
        settle();
        schedule();
      }, { passive: true });
      slider.addEventListener('mouseenter', () => {
        state.paused = true;
        window.clearTimeout(state.timer);
      });
      slider.addEventListener('mouseleave', () => {
        state.paused = false;
        schedule();
      });
      settle();
      schedule();
      return;
    }

    const state = { index: 0, timer: 0 };

    const slidesPerView = () => {
      const width = window.innerWidth;
      const key = width >= 1025 ? '1025' : width >= 768 ? '768' : '0';
      const configured = options.breakpoints?.[key]?.slidesPerView ?? options.slidesPerView ?? 1;
      return Math.max(1, Math.min(slides.length, Number(configured) || 1));
    };

    const render = () => {
      const perView = slidesPerView();
      const lastIndex = Math.max(0, slides.length - perView);
      if (state.index > lastIndex) state.index = 0;
      slides.forEach((slide, index) => {
        const active = index >= state.index && index < state.index + perView;
        slide.style.flex = `0 0 ${100 / perView}%`;
        slide.classList.toggle('swiper-slide-active', active);
        slide.classList.toggle('ecom-box-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      wrapper.style.transform = `translate3d(-${state.index * (100 / perView)}%, 0, 0)`;
      if (pagination) {
        const pageCount = lastIndex + 1;
        pagination.replaceChildren(...Array.from({ length: pageCount }, (_, index) => {
          const bullet = document.createElement('button');
          bullet.type = 'button';
          bullet.className = 'ecom-swiper-pagination-bullet';
          bullet.setAttribute('aria-label', `Slide ${index + 1}`);
          bullet.classList.toggle('is-active', index === state.index);
          bullet.addEventListener('click', () => {
            state.index = index;
            render();
          });
          return bullet;
        }));
      }
      setDisabled(previous, lastIndex === 0 || (!options.loop && state.index === 0));
      setDisabled(next, lastIndex === 0 || (!options.loop && state.index === lastIndex));
    };

    const move = (direction) => {
      const perView = slidesPerView();
      const lastIndex = Math.max(0, slides.length - perView);
      const loop = options.loop === true;
      const nextIndex = state.index + direction;
      state.index = nextIndex > lastIndex ? (loop ? 0 : lastIndex) : nextIndex < 0 ? (loop ? lastIndex : 0) : nextIndex;
      render();
    };

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    window.addEventListener('resize', render, { passive: true });

    const autoplay = options.autoplay?.enabled === true;
    if (autoplay && slides.length > 1) {
      const delay = Math.max(1500, Number(options.autoplay?.delay) || 6000);
      const start = () => {
        window.clearInterval(state.timer);
        state.timer = window.setInterval(() => move(1), delay);
      };
      const stop = () => window.clearInterval(state.timer);
      start();
      if (options.autoplay?.pauseOnMouseEnter) {
        slider.addEventListener('mouseenter', stop);
        slider.addEventListener('mouseleave', start);
      }
    }

    render();
  };

  const initTabs = (root) => {
    if (root.dataset.mpNativeTabsReady === 'true') return;
    const navs = [...root.querySelectorAll(':scope > .tabs__navs .tabs__nav')];
    const panels = [...root.querySelectorAll(':scope > .core__group--items > .tab__item')];
    if (!navs.length || navs.length !== panels.length) return;
    root.dataset.mpNativeTabsReady = 'true';

    const select = (index, focus = false) => {
      navs.forEach((nav, navIndex) => {
        const active = navIndex === index;
        nav.classList.toggle('ecom-item-active', active);
        nav.setAttribute('role', 'tab');
        nav.setAttribute('tabindex', active ? '0' : '-1');
        nav.setAttribute('aria-selected', active ? 'true' : 'false');
        if (panels[navIndex]?.id) nav.setAttribute('aria-controls', panels[navIndex].id);
      });
      panels.forEach((panel, panelIndex) => {
        const active = panelIndex === index;
        panel.classList.toggle('ecom-item-active', active);
        panel.hidden = !active;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (focus) navs[index]?.focus();
    };

    let initial = Math.max(0, navs.findIndex((nav) => nav.classList.contains('ecom-item-active')));
    navs.forEach((nav, index) => {
      nav.addEventListener('click', () => select(index));
      nav.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          select(index);
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          select((index + 1) % navs.length, true);
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          select((index - 1 + navs.length) % navs.length, true);
        }
      });
    });
    select(initial);
  };

  const init = (scope = document) => {
    if (scope.matches?.(sectionSelector)) {
      scope.querySelectorAll('.ecom-swiper-container').forEach(initSlider);
      scope.querySelectorAll('.ecom__tabs').forEach(initTabs);
    }
    scope.querySelectorAll?.(`${sectionSelector} .ecom-swiper-container`).forEach(initSlider);
    scope.querySelectorAll?.(`${sectionSelector} .ecom__tabs`).forEach(initTabs);
  };

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
